import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const PostsSection = styled.section`
  width: 100%;
  background-color: #f5f5f5;
`;

const Post = styled.a`
  position: relative;
  transition: transform 420ms cubic-bezier(0.165, 0.84, 0.44, 1);
`;

const PostInfo = styled.div`
  &:after {
    content: "•";
    margin: 0 0.36rem;
  }
`;

const PostImage = styled(GatsbyImage)`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const S = {
  PostsSection,
  Post,
  PostInfo,
  PostImage,
};

export default S;
